import Footer from "../Components/footer";
import Header from "./header1";
import { RWebShare } from "react-web-share";
import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  requestEmpLogin,
  requestLogin,
  requestCountLastweekJob,
  requestRecentlyJob,
  requestCategory,
  requestAddBookmark,
  userLogout
} from "../Redux/actions";
import WOW from "wowjs";
import img from "../images/emp.jpg";
import image from "../images/extraLogo.png";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import Swal from "sweetalert2";
import About from "../Section/aboutUsSection";
import Apply from "../Section/applyProcessSection";
import Jobcategory from "../Section/jobCategorySection";
import Client from "../Section/clientLogoSection";

function Home(props) {
  useEffect(() => {
    new WOW.WOW().init();
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [user, setUSer] = useState({});
  const [emp, setEmp] = useState({});
  const [jobcount, setjobcount] = useState(0);
  const [jobs, setjobs] = useState([]);
  const [notificationPermission, setNotificationPermission] = useState('default');
  
  useEffect(() => {
    props.requestCountLastweekJob();
    props.requestCategory();
    props.requestRecentlyJob({});
  }, []);

  useEffect(() => {
    let loginData = props.candidate.loginData;
    if (loginData !== undefined) {
      if (loginData?.data?.status == "success") {
        setUSer(loginData.data.data);
        props.requestRecentlyJob({
          token: loginData.data.data.token,
        });
      }
    } else {
      props.requestRecentlyJob({});
    }
  }, []);

  useEffect(() => {
    let empLoginData = props.employee.empLoginData;
    if (empLoginData !== undefined) {
      if (empLoginData?.data?.status == "success") {
        setEmp(empLoginData.data.data);
      }
    }
  }, [props.employee.empLoginData]);

  useEffect(() => {
    let loginData = props.candidate.loginData;
    if (loginData !== undefined) {
      if (loginData?.data?.status == "success") {
        setUSer(loginData.data.data);
      }
    }
  }, [props.candidate.loginData]);

  useEffect(() => {
    let lastweekjob = props.candidate.lastWeekJobCount;
    if (lastweekjob !== undefined) {
      if (lastweekjob?.data?.status == "success") {
        setjobcount(lastweekjob.data.data);
      }
    }
  }, [props.candidate.lastWeekJobCount]);

  useEffect(() => {
    let recentlyjob = props.candidate.recentlyAddedJobData;
    if (recentlyjob !== undefined) {
      if (recentlyjob?.data?.status == "success") {
        setjobs(recentlyjob.data.data);
      }
    }
  }, [props.candidate.recentlyAddedJobData]);

  function bookmarkJobs(id) {
    if (user.id) {
      props.requestAddBookmark({
        token: user.token,
        id: id,
        data: {},
      });
    } else {
      localStorage.setItem("link", `/home`);
      navigate("/login");
    }
  }

  useEffect(() => {
    if (user.id) {
      let addBookmarkedData = props.candidate.addBookmarkedData;
      if (addBookmarkedData !== undefined) {
        if (addBookmarkedData?.data?.status == "success") {
          Swal.fire("Good job!", "Bookmarked for Job successfully.", "success");
          props.candidate.addBookmarkedData = undefined;
          let loginData = props.candidate.loginData;
          if (loginData !== undefined) {
            if (loginData?.data?.status == "success") {
              setUSer(loginData.data.data);
              props.requestRecentlyJob({
                token: loginData.data.data.token,
              });
            }
          } else {
            props.requestRecentlyJob();
          }
        } else {
          Swal.fire("Error!", "Already bookmarked for the job.", "error");
          props.candidate.addBookmarkedData = undefined;
        }
      }
    } else {
      let addBookmarkedData = props.candidate.addBookmarkedData;
      if (addBookmarkedData !== undefined) {
        if (addBookmarkedData?.data?.status == "Token is Expired") {
          props.userLogout()
        }
      }
    }
  }, [props.candidate.addBookmarkedData]);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {},
    debounce: 300,
  });
  const [categories, setCategories] = useState([]);
  const [items, setitems] = useState([]);
  const [state, setState] = useState({
    suggestions: [],
    text: "",
  });
  useEffect(() => {
    let categoryData = props.candidate.categoryData;
    if (categoryData) {
      if (categoryData?.data?.status == "success") {
        setCategories(categoryData.data.data.categories);
      }
    }
  }, [props.candidate.categoryData]);
  useEffect(() => {
    {
      categories.map((item1) => {
        if (items.indexOf(item1.name) === -1) {
          items.push(item1.name);
        }
      });
    }
  }, [categories]);
  function suggestionSelected(value) {
    setState(() => ({
      text: value,
      suggestions: [],
    }));
  }

  const onTextChanged = (e) => {
    const value = e.target.value;
    let suggestions = [];
    if (value.length > 0) {
      const regex = new RegExp(`^${value}`, "i");
      suggestions = items.sort().filter((v) => regex.test(v));
    }
    setState(() => ({ suggestions, text: value }));
  };

  function renderSuggestionsTitle() {
    const { suggestions } = state;
    if (suggestions.length === 0) {
      return null;
    }
    return (
      <div className="srchList">
        <div
          style={{
            backgroundColor: "white",
            margin: "0px -2px",
            marginTop: "1px",
            border: "2px solid rgba(13, 110, 253, .25)",
            borderRadius: "3px",
            padding: "5px",
            cursor: "pointer",
          }}
        >
          <ul>
            {suggestions.map((item) => (
              <li
                style={{ fontSize: "14px", color: "black" }}
                onClick={() => suggestionSelected(item)}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  const handleSelect =
    ({ description }) =>
      () => {
        setValue(description, false);
        clearSuggestions();
      };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;
      const text = main_text + ", " + secondary_text;
      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <small style={{ fontSize: "14px", color: "black" }}>
            {text.length > 20 ? text.substring(0, 20) + "..." : text}
          </small>
        </li>
      );
    });

  function submitForm(e) {
    e.preventDefault();
    localStorage.setItem("jobKeyword", state.text);
    localStorage.setItem("jobLocation", value);
    navigate("/browseJobs");
  }

  function commentFunction(id) {
    localStorage.setItem("comment", "comment");
    navigate(`/jobDetails/${id}`);
  }

  return (
    <>
      <Header name="Home" />
      <section className="p-0 cover-background full-screen ipad-top-space-margin md-h-auto position-relative md-pb-70px"
        style={{backgroundImage: "url('front/images/demo-application-home-banner.jpg')"}}>
        <div id="particles-style-01" className="h-100 position-absolute left-0px top-0 w-100" data-particle="true"
            data-particle-options='{"particles": {"number": {"value": 12,"density": {"enable": true,"value_area": 2000}},"color": {"value": ["#8f76f5", "#a65cef", "#c74ad2", "#e754a4", "#ff6472"]},"shape": {"type": "circle","stroke":{"width":0,"color":"#000000"}},"opacity": {"value": 0.3,"random": false,"anim": {"enable": false,"speed": 1,"sync": false}},"size": {"value": 8,"random": true,"anim": {"enable": false,"sync": true}},"line_linked":{"enable":false,"distance":0,"color":"#ffffff","opacity":0.4,"width":1},"move": {"enable": true,"speed":1,"direction": "right","random": false,"straight": false}},"interactivity": {"detect_on": "canvas","events": {"onhover": {"enable": false,"mode": "repulse"},"onclick": {"enable": false,"mode": "push"},"resize": true}},"retina_detect": false}'>
        </div>
        <div className="container h-100 position-relative z-index-9">
            <div className="row align-items-center h-100 justify-content-center">
                <div className="col-lg-6 col-md-10 text-center position-relative md-mb-50px"
                    data-anime='{ "el": "childs", "opacity": [0, 1], "translateY": [80, 0], "staggervalue": 200, "duration": 900, "easing": "easeOutCirc" }'>
                    <div className="d-inline-block">
                        <div className="text-end w-90 lg-w-80 ms-auto animation-float">
                            <img src="https://via.placeholder.com/539x948" alt="" />
                        </div>
                    </div>
                    <div
                        className="w-60 position-absolute left-minus-40px lg-left-minus-30px xs-left-15px xs-w-50 bottom-minus-50px mb-30 xs-mb-15">
                        <img src="https://via.placeholder.com/236x282"
                            className="border-radius-18px box-shadow-extra-large" alt="" />
                    </div>
                </div>
                <div className="col-xl-5 ps-3 md-ps-15px col-lg-6 col-md-9 position-relative text-center text-lg-start"
                    data-anime='{ "el": "childs", "translateY": [50, 0], "perspective": [1200,1200], "scale": [1.1, 1], "rotateY": [50, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'>
                    <div className="fs-90 xl-fs-80 lh-80 mb-35px text-dark-gray ls-minus-3px">
                        <span className="d-inline-block">Best mobile</span>
                        <span className="fw-800 d-inline-block">app award.</span>
                    </div>
                    <span className="fs-19 w-90 xs-w-100 d-block lh-32 mb-35px mx-auto mx-lg-0">Your ultimate travel
                        partner. Carries the information you need while travelling.</span>
                    <div className="row pe-20px md-ps-25px sm-px-0 md-border-end-0">
                        <a href="#" className="col-6">
                            <img src="front/images/app-store-white.svg"
                                className="box-shadow-medium-bottom box-shadow-quadruple-large-hover border-radius-4px"
                                alt="" />
                        </a>
                        <a href="#" className="col-6">
                            <img src="front/images/play-store-white.svg"
                                className="box-shadow-medium-bottom box-shadow-quadruple-large-hover border-radius-4px"
                                alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- start marquees--> */}
        <div
            className="marquees-text fw-800 fs-250 md-fs-200 ls-minus-10px text-dark-gray text-nowrap position-absolute bottom-130px opacity-1 text-center">
            billing and inventory software</div>
        {/* <!-- end marquees--> */}
    </section>
    {/* <!-- end section--> */}
    {/* <!-- start section--> */}
    <section className="pb-0 half-section lg-pt-0">
        <div className="container">
            <div className="row"
                data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay": 300, "staggervalue": 250, "easing": "easeOutQuad" }'>
                <div className="col text-center">
                    <span className="fs-19 alt-font mb-35px d-inline-block text-dark-gray fw-600 ls-minus-05px">Join the
                        <span className="fw-800">10000+</span> people trusting travel application.</span>
                </div>
            </div>
            <div className="row row-cols-1 row-cols-lg-5 row-cols-md-3 row-cols-sm-2 clients-style-06 justify-content-center"
                data-anime='{ "el": "childs", "translateX": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 250, "easing": "easeOutQuad" }'>
                {/* <!-- start client item--> */}
                <div className="col client-box text-center md-mb-35px">
                    <a href="#"><img src="front/images/logo-walmart.svg" className="h-35px" alt="" /></a>
                </div>
                {/* <!-- end client item--> */}
                {/* <!-- start client item--> */}
                <div className="col client-box text-center md-mb-35px">
                    <a href="#"><img src="front/images/logo-logitech.svg" className="h-35px" alt="" /></a>
                </div>
                {/* <!-- end client item--> */}
                {/* <!-- start client item--> */}
                <div className="col client-box text-center md-mb-35px">
                    <a href="#"><img src="front/images/logo-monday.svg" className="h-35px" alt="" /></a>
                </div>
                {/* <!-- end client item--> */}
                {/* <!-- start client item--> */}
                <div className="col client-box text-center sm-mb-35px">
                    <a href="#"><img src="front/images/logo-google.svg" className="h-35px" alt=""/></a>
                </div>
                {/* <!-- end client item--> */}
                {/* <!-- start client item--> */}
                <div className="col client-box text-center">
                    <a href="#"><img src="front/images/logo-paypal.svg" className="h-35px" alt=""/></a>
                </div>
                {/* <!-- end client item--> */}
            </div>
        </div>
    </section>
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => {
  return { employee: state.employee, candidate: state.candidate };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestEmpLogin,
      requestLogin,
      requestCountLastweekJob,
      requestRecentlyJob,
      requestCategory,
      requestAddBookmark,
      userLogout
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
